/**
 * Type-safe API client for the Example Environment.
 *
 * Generated from packages/contracts/openapi/example.yaml using openapi-fetch.
 * Routes through the gateway proxy at /api/modules/example/*.
 *
 * ADR-0017 Workstream 2.
 */
import createClient from 'openapi-fetch'
import type { paths } from './generated/example.d.ts'
import { fetchWithTimeout } from '../lib/fetchWithTimeout'

/**
 * Example environment API client.
 *
 * Base URL points to the gateway proxy path
 * `/api/modules/example` (ADR-0069 rename from
 * `/api/workflows/example`). The gateway forwards to the example
 * environment service, stripping the proxy prefix. The OpenAPI
 * paths in example.yaml are absolute under the environment service
 * (`/api/training/runs`), so the baseUrl prepends the proxy prefix
 * to every request.
 */
export const exampleClient = createClient<paths>({
  baseUrl:
    typeof window !== 'undefined' && window.location.origin
      ? `${window.location.origin}/api/modules/example`
      : 'http://localhost:5000/api/modules/example',
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json',
  },
  fetch: fetchWithTimeout,
})
